/* eslint-disable unicorn/consistent-function-scoping */
import { AppState, AppThunkDispatch } from '../..';
import { enqueueSnackbarAction } from '../../snackbar/actions';
import { DeviceTypeActionNames } from './types';
import DeviceTypeConfiguration from '../../../services/config-capabilities';
// import FileTypeConfiguration from '../../../services/file-type-configurations';

export const getDefaults = () => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
  const {
    login: { client, envVariables },
  } = getState();
  const deviceTypeConfiguration = new DeviceTypeConfiguration(
    client,
    envVariables.configCapability,
  );
  const response = await deviceTypeConfiguration.getAllConfigCapabilities({});
  const deviceTypeConfigs = response.data.configCapabilities;
  if (deviceTypeConfigs) {
    dispatch({
      type: DeviceTypeActionNames.SET_DEFAULTS,
      payload: deviceTypeConfigs,
    });
  }
};

export const editDeviceTypeConfig =
  (device: any, deviceType: string) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const deviceTypeConfiguration = new DeviceTypeConfiguration(
      client,
      envVariables.configCapability,
    );
    try {
      const response = await deviceTypeConfiguration.editConfigCapabilities(device, deviceType);
      if (response.data) {
        dispatch(
          enqueueSnackbarAction({
            message: 'Configuration Saved',
            options: {
              variant: 'success',
            },
          }),
        );
        dispatch({
          type: DeviceTypeActionNames.SET_DEVICE_TYPE_CONFIG,
          payload: response.data,
        });
      }
    } catch (error) {
      dispatch(
        enqueueSnackbarAction({
          message: `${error.message}`,
          options: {
            variant: 'error',
          },
        }),
      );
    }
  };
